/**
 * 侧边栏状态枚举
 */
export const enum SidebarStatusEnum {
  /**
   * 展开
   */
  OPENED = "opened",

  /**
   * 关闭
   */
  CLOSED = "closed",
}
